<template>
  <ExActionsPopUp
    :value="show"
    headline="Activate Department"
    :icon="'department_icon'"
    :htmlInfo="info"
    :destructive="false"
    :primary="true"
    actionLabel="Activate"
    :centerHeadline="true"
    actionsTopSpacing="32px"
    @onAction="$emit('onActivate')"
    @input="$emit('onClose')"
    data-testid="activate-department-popup"
    :applyBorderClass="true"
    :backgroundPatternBottomRight="true"
    :width="500"
    :orgObjectType="'Department'"
  >
  </ExActionsPopUp>
</template>
<script setup>
import { computed } from "vue";
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  name: {
    type: String,
    default: "",
  },
});

defineEmits(["onActivate", "onClose"]);

const formattedInfo = computed(() => {
  return `<div style="max-width: 500px; margin: 0 auto; margin-top: 26px;">You are about to activate irreversibly Department ${props.name}. Once you activate, you cannot move it back to status Draft.</div>`;
});

const info = computed(() => {
  return formattedInfo.value;
});
</script>
